import setIsLoading from "reducers/lockingSystemReducer/utils/setIsLoading"
import { getSelectedConfigurationsAfterOuterLengthChange } from "@secureo/common/reducers/productDetailPageReducer"
import getCylinderConfigurationVariantSku from "@secureo/common/reducers/productDetailPageReducer/utils/getCylinderConfigurationVariantSku"
import fetchCylinderConfigurationVariant from "@secureo/common/utils/commerceTools/graphql/queries/fetchCylinderConfigurationVariant"
import { setComponentCylinderConfigurationVariant } from "./setComponentCylinderConfigurationVariant"

import {
	LockingSystemReducerState,
	DispatchLockingSystemReducer,
} from "reducers/lockingSystemReducer"
import { ProviderContext } from "notistack"

export const setSelectedComponentOuterLength = async (
	accessToken: string,
	reducerState: LockingSystemReducerState,
	dispatch: DispatchLockingSystemReducer,
	uuid: string,
	selectedOuterLength: number,
	enqueueSnackbar: ProviderContext["enqueueSnackbar"],
) => {
	const { locale } = reducerState

	const component = reducerState.componentsByUuid[uuid]

	setIsLoading(dispatch, true)

	const { cylinderConfigurationType, attributes, variantsByVariantId } = component

	const { selectedSystem, selectedInnerLength } = getSelectedConfigurationsAfterOuterLengthChange(
		cylinderConfigurationType,
		attributes,
		component.selectedSystem,
		selectedOuterLength,
		component.selectedInnerLength,
	)

	dispatch({
		type: "SET_COMPONENT_CONFIGURATIONS",
		payload: {
			uuid,
			selectedOuterLength,
			selectedInnerLength,
		},
	})

	const componentWithUpdatedSelectedConfigurations = {
		...component,
		selectedOuterLength,
		selectedInnerLength,
	}

	const cylinderConfigurationVariantSku = getCylinderConfigurationVariantSku(
		cylinderConfigurationType,
		attributes,
		variantsByVariantId,
		selectedSystem,
		selectedOuterLength,
		selectedInnerLength,
	)
	const cylinderConfigurationVariant = await fetchCylinderConfigurationVariant(
		accessToken,
		cylinderConfigurationVariantSku,
		locale,
	)

	setComponentCylinderConfigurationVariant(
		dispatch,
		reducerState,
		componentWithUpdatedSelectedConfigurations,
		cylinderConfigurationVariant,
		enqueueSnackbar,
	)

	setIsLoading(dispatch, false)
}
